import React from 'react';
import { Card } from '../../../components/CssFrameworkComponents';
import SettingsToggleRow from '../components/SettingsToggleRow';
import { useAutoSaveSetting } from '../hooks/useAutoSaveSetting';
import { useOptimisticChecked } from '../hooks/useOptimisticChecked';
import { usePrerenderUser } from '../../../hooks/usePrerenderUser';
import { SETTINGS_RESTRICTED_ROLES } from '../settingsRoles';

const DESCRIPTIONS = [
  // eslint-disable-next-line max-len
  "This option allows the renderer to wait for the images to be loaded, which slows down the rendering and is only recommended when your website's logic depends on image loading events.",
];

const TITLE = 'Image loading';

const ImageLoadingCard = () => {
  const { settings } = usePrerenderUser();
  const { save, status, retry } = useAutoSaveSetting();
  const { checked, setPendingChecked } = useOptimisticChecked(settings.loadImages, status);

  const toggleLoadImages = (nextChecked) => {
    setPendingChecked(nextChecked);
    save({ loadImages: nextChecked });
  };

  return (
    <Card title={TITLE}>
      <div className="col">
        {DESCRIPTIONS.map((description) => (
          <div className="row" key={description}>
            <p>{description}</p>
          </div>
        ))}
        <SettingsToggleRow
          checked={checked}
          onChange={toggleLoadImages}
          disabled={status === 'saving'}
          disabledFor={SETTINGS_RESTRICTED_ROLES}
          status={status}
          onRetry={retry}
        />
      </div>
    </Card>
  );
};

export default ImageLoadingCard;
